'use client';

import React, { useMemo } from 'react';
import ClientModuleWrapper from '@/aem-dsm-mappers/ClientModuleWrapper';
import { createActionIndicatorProps } from '@/aem-dsm-mappers/utils/actionIndicatorMapper';

export default function ArticleTextOnlyHeroWrapper(props) {
  // Memoize the DSM props to prevent object recreation on each render
  const dsmProps = useMemo(
    () => ({
      ...props,
      actionIcons: props?.actionIcons?.map(createActionIndicatorProps) || [],
    }),
    [props],
  );

  return (
    <ClientModuleWrapper
      exportName="ArticleTextOnlyHero"
      componentType="article-text-only-hero"
      dsmProps={dsmProps}
    />
  );
}
